import { Component, OnInit, Inject } from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { SentMessageDialogComponent } from '../sent-message-dialog/sent-message-dialog.component';
import { Message } from '../../models/message';
import { JobsOffer } from '../../models/jobs-offer';
import { Router, ActivatedRoute } from '@angular/router';
import { MessagingService } from '../../services/messaging.service';
import { UserProfile } from '../../models/user-profile';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Observable} from "rxjs";
import { JobOffersService } from '../../services/job-offers.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

@Component({
  selector: 'app-send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.css']
})
export class SendMessageComponent implements OnInit {
  publicating: boolean = false;
  nameComponent:string;
  userId:string;
  job:JobsOffer;
  jobs:Observable<any[]>;
  message: Message;
  useFilter;
  jobId: string;
  selected: boolean;
  test: boolean;
  interview: boolean;
  rejected: boolean;
  screening: boolean;
  hired: boolean;
  read: boolean;
  unread: boolean;
  favorite2 = false;

  optionsModel: number[];
  myOptions: IMultiSelectOption[];

  mySettings: IMultiSelectSettings = {
      enableSearch: false,
      checkedStyle: 'fontawesome',
      itemClasses: 'button-ddd',
      containerClasses: 'button-ddd',
      buttonClasses: 'btn button-ddd btn-default btn-block',
      dynamicTitleMaxItems: 10,
      fixedTitle: true,
      displayAllSelectedText: true
  };

  myTexts: IMultiSelectTexts = {
      checkAll: 'Seleccionar Todos',
      uncheckAll: 'Remover Todos',
      checked: 'Estado Seleccionado',
      checkedPlural: 'Estados Seleccionados',
      searchPlaceholder: 'Buscar',
      defaultTitle: 'Seleccionar Estado',
      allSelected: 'Seleccionar Todos',
  };


  constructor(
      public dialogRef: MdDialogRef<SendMessageComponent>,
      public dialog: MdDialog,
      public msg:MessagingService,
      private jobService: JobOffersService,
      private applyStatusService: ApplyStatusService,
  @Inject(MD_DIALOG_DATA) public data: any) {
    this.nameComponent = this.data.nameComponent;
    this.userId = this.data.userId;
    this.job = this.data.job;
    this.useFilter = this.data.useFilter != null ? this.data.useFilter : true;
    this.message = new Message;

    if(this.nameComponent != 'offer') {
      this.jobs = this.data.jobs.do((res) => {
        if (res.length > 0) {
          this.jobId = res[0].id;
        }
      });
    } else {
      this.jobId = this.job.id;
    }

    this.jobService.getOffersById(this.jobId).subscribe(
      data => {
        this.job = data;
      },
      error => {
        console.log('error loading job');
      }
    );
   }

  ngOnInit() {

    this.applyStatusService.getApplyStatusList(1, 10, undefined, 2).subscribe(
        data => {
          let dat= [];
          dat.push({ id: 111, name: "Favoritos" });
          dat.push({ id: 0, name: "Sin Leer" });
          dat.push({ id: 100, name: "Leídos" });

          data.applystatus.forEach(element => {
            dat.push({ id: element.id, name: element.name });
          });
          dat.push({ id: 275, name: "Preseleccionados" });
          dat.push({ id: -1, name: "Rechazados" });
          dat.push({ id: 300, name: "Seleccionados" });
          this.myOptions = dat;
        }
      );
  }
  getOfferInput($event){
    this.jobId = $event.id;
  }

  onChange($event) {
  }

  sendMessage() {
      let status = [];

      // if (this.rejected) {
      //   status.push('-1');
      // }
      // if (this.read) {
      //   status.push('100');
      // }
      // if (this.unread) {
      //   status.push('0');
      // }
      // if (this.screening) {
      //   status.push('200');
      // }
      // if (this.interview) {
      //   status.push('250');
      // }
      // if (this.test) {
      //   status.push('265');
      // }
      // if (this.selected) {
      //   status.push('275');
      // }
      // if (this.hired) {
      //   status.push('300');
      // }

      if(this.optionsModel){
        this.optionsModel.forEach(element => {
          console.log(element);
          let number = ""+element
          if (element == 111){
            this.favorite2 = true;
          }else {
            status.push(number);
          }

        });
      }

      if (this.useFilter) {
        this.msg.sendMassive(this.jobId, this.message, this.userId, this.favorite2, status)
          .subscribe(
            data => {
              this.dialog.open(MessageBoxDialog, {data: {title: 'Mensaje Enviado', success:true, showIcon:true}});
              this.dialogRef.close('yes');
            },
            error => {
              console.log(error);
              this.dialog.open(MessageBoxDialog, {data: {title: 'Mensaje No Enviado', message: 'No hay candidatos para el filtro seleccionado', alert: true, showIcon:true}});
            }
          );
      } else {
        this.msg.send(this.job.id, this.message, this.userId)
          .subscribe(
            data => {
              this.dialog.open(MessageBoxDialog, {data: {title: 'Mensaje Enviado', success:true, showIcon:true}});
              this.dialogRef.close('yes');
            },
            error => {
              console.log(error);
              this.dialog.open(MessageBoxDialog, {data: {title: 'Mensaje No Enviado', message: 'No hay candidatos para el filtro seleccionado', alert: true, showIcon:true}});
            }
          );
      }
  }

  onPostMessage() {
    this.publicating = true;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/send-message/send-message.component.ts